import type { CSSProperties } from 'react'

interface AnimatedCheckProps {
  className?: string
  /** Si es false, el trazo se muestra completo sin dibujarse. */
  animate?: boolean
}

/**
 * Check con trazo que se dibuja una sola vez (momento focal "misión cumplida").
 * Usa pathLength=100 para que `.motion-draw` funcione sin medir el path.
 */
export function AnimatedCheck({ className, animate = true }: AnimatedCheckProps) {
  const draw = animate ? 'motion-draw' : ''
  const style = { '--len': 100 } as CSSProperties
  return (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
      className={className}
      aria-hidden="true"
    >
      <circle cx="12" cy="12" r="10" pathLength={100} className={draw} style={style} />
      <path d="m8.5 12.5 2.5 2.5 4.5-5" pathLength={100} className={draw} style={{ ...style, animationDelay: '220ms' }} />
    </svg>
  )
}
